import { useState } from "react";
import { Col, Container, FormControl, InputGroup, Row } from "react-bootstrap";
import RangeSlider from "react-bootstrap-range-slider";

import Modal from "../modal";

import token from "../../assets/token.png";

import { STAKING_contract } from "../../Constants.js";

import "./stakingModalStyles.css";

const TRANSACTIONS_URL = `https://polygonscan.com/address/${STAKING_contract.address}`;
const POOL_APYS = {
  geos: {
    apy: {
      2: 48,
      4: 60,
    },
    weight: 0.27,
  },
  lp: {
    apy: {
      2: 120,
      4: 180,
    },
    weight: 0.72,
  },
};

const LOCKTIME_IN_DAYS = {
  2: 15,
  4: 30,
};

const StakingModal = ({
  title,
  isLoading,
  displayModal,
  setDisplayModal,

  stakingType,
  balance,
  amount,
  isApproved,
  approveTokens,
  geoStake,

  lockTime,
  setLockTime,
}) => {
  const [val, setVal] = useState(amount);

  const getAPY = (pool, weeks) => POOL_APYS[pool]["apy"][weeks];
  const getWeight = (pool) => POOL_APYS[pool]["weight"];

  const getLockTimeInDays = (time) => LOCKTIME_IN_DAYS[time];

  const onClick = () => {
    return isApproved
      ? geoStake(val.toString(), lockTime)
      : approveTokens(val.toString());
  };

  const getBodyContent = () => (
    <Container className="staking-modal-container">
      <Row className="staking-modal-row mb-4">
        <Col xs={12}>
          <button
            className="staking-modal-button purple mx-auto w-100"
            disabled
          >
            Locked
          </button>
        </Col>
      </Row>
      <Row className="staking-modal-row bold staking-modal-row-lock">
        <Col xs={6}>
          <span>
            Lock for:&nbsp;
            <span className="purple">{`${getLockTimeInDays(
              lockTime
            )} days`}</span>
          </span>
        </Col>
        <Col className="text-right">
          <span>
            Weight:&nbsp;
            <span className="purple">{getWeight(stakingType)}</span>
          </span>
        </Col>
      </Row>
      <Row className="staking-modal-row bold staking-modal-row-lock">
        <Col xs={12}>
          <RangeSlider
            className="slider"
            size="sm"
            value={lockTime}
            min={2}
            max={4}
            step={2}
            tooltip="off"
            onChange={(changeEvent) => setLockTime(changeEvent.target.value)}
          />
        </Col>
      </Row>
      <Row className="staking-modal-row bold staking-modal-row-lock">
        <Col xs={6}>
          <span className="ml-1">2</span>
        </Col>
        <Col className="text-right">
          <span>4</span>
        </Col>
      </Row>
      <Row className="staking-modal-row bold staking-modal-row-amount pt-3 ">
        <Col xs={6}>
          <span>Amount</span>
        </Col>
        <Col className="text-right">
          <span>{`Balance: ${
            stakingType === "geos"
              ? balance.geos.toString()
              : balance.lp.toString()
          }`}</span>
        </Col>
      </Row>
      <Row className="staking-modal-row bold">
        <Col xs={12}>
          <InputGroup>
            <FormControl
              className="amount"
              placeholder="0"
              value={val}
              onChange={(e) => setVal(e.target.value)}
            />
            <InputGroup.Append>
              <button
                className="button-max"
                onClick={() =>
                  setVal(
                    stakingType === "geos"
                      ? balance.geos.toString()
                      : balance.lp.toString()
                  )
                }
              >
                Max
              </button>
            </InputGroup.Append>
          </InputGroup>
        </Col>
      </Row>
      <Row className="staking-modal-row">
        <Col xs={12}>
          <span className="apy">{`EST APY: ${getAPY(
            stakingType,
            lockTime
          )}%`}</span>
        </Col>
      </Row>
    </Container>
  );

  const getFooterLabel = () =>
    !isApproved ? (
      "You must first approve your wallet to stake your tokens"
    ) : (
      <>
        It will take some time for the contract call to propagate and show the
        staked amount. In the meantime you can check the transactions&nbsp;
        <a
          className="underline"
          target="_blank"
          rel="noopener noreferrer"
          href={TRANSACTIONS_URL}
        >
          <span>here</span>
        </a>
      </>
    );

  return (
    <Modal
      size="md"
      title={title}
      imageTitle={token}
      bodyContent={getBodyContent()}
      showFooter={true}
      showButtonFooter={true}
      buttonFooterLabel={isApproved ? "Stake" : "Approve"}
      buttonFooterOnPress={() => onClick()}
      footerLabel={getFooterLabel()}
      displayModal={displayModal}
      setDisplayModal={setDisplayModal}
      isLoading={isLoading}
    />
  );
};

export default StakingModal;
